<script>
	export let width = '200px';
	export let height = '200px';

	let style = `width: ${width}; height: ${height}`;
</script>

<style>
	div {
		display: inline-block;
		margin: 0 .3rem;
	}
</style>

<div {style}>
	<svg width="100%" height="100%" viewBox="0 0 500 500" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
	    <g transform="matrix(1.70034,0,0,1.70034,-68.5765,81.1151)">
	        <circle cx="229.792" cy="99.618" r="42.726"/>
	    </g>
	    <g transform="matrix(1.1793,0,0,1.1793,113.582,-16.2004)">
	        <path d="M238.459,102.588C238.459,68.786 211.016,41.343 177.214,41.343L115.253,41.343L115.253,164.549L176.498,164.549C210.695,164.549 238.459,136.785 238.459,102.588L238.459,102.588Z"/>
	    </g>
	    <g transform="matrix(-1.1793,0,0,1.1793,386.418,-16.2004)">
	        <path d="M238.459,102.588C238.459,68.786 211.016,41.343 177.214,41.343L115.253,41.343L115.253,164.549L176.498,164.549C210.695,164.549 238.459,136.785 238.459,102.588L238.459,102.588Z"/>
	    </g>
	    <g transform="matrix(-1.1793,0,0,1.1793,386.418,128.267)">
	        <path d="M238.459,102.588C238.459,68.786 211.016,41.343 177.214,41.343L115.253,41.343L115.253,164.549L176.498,164.549C210.695,164.549 238.459,136.785 238.459,102.588L238.459,102.588Z" style="fill:rgb(6,0,14);"/>
	    </g>
	    <g transform="matrix(-1.1793,0,0,1.1793,386.418,273.393)">
	        <path d="M238.459,102.588C238.459,68.786 211.016,41.343 177.214,41.343L115.253,41.343L115.253,103.304C115.253,137.106 142.696,164.549 176.498,164.549C210.695,164.549 238.459,136.785 238.459,102.588L238.459,102.588Z"/>
	    </g>
	</svg>
</div>